import { render, staticRenderFns } from "./SavedListDropdown.vue?vue&type=template&id=1c2f634c&"
import script from "./SavedListDropdown.vue?vue&type=script&lang=js&"
export * from "./SavedListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports